msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-08 15:57-0500\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "{adFormatName} are not available for self-managed campaigns. Please contact sales to inquire."
msgstr "{adFormatName} are not available for self-managed campaigns. Please contact sales to inquire."

msgid "{billingType} price must be {price} or higher"
msgstr "{billingType} price must be {price} or higher"

msgid "{campaignFormat} pricing configuration option(s):"
msgstr "{campaignFormat} pricing configuration option(s):"

msgid "{length}/{maxLength} characters"
msgstr "{length}/{maxLength} characters"

msgid "{type} status cannot be updated"
msgstr "{type} status cannot be updated"

msgid "*Limited time only. Available to new advertisers, and those who ran campaigns prior to September 30, 2023. Eligible for Push Notification ads."
msgstr "*Limited time only. Available to new advertisers, and those who ran campaigns prior to September 30, 2023. Eligible for Push Notification ads."

msgid "+{count} more"
msgstr "+{count} more"

msgid "1 Day"
msgstr "1 Day"

msgid "30 Days"
msgstr "30 Days"

msgid "401 Forbidden"
msgstr "401 Forbidden"

msgid "7 Days"
msgstr "7 Days"

msgid "A forbidden error was returned. You may need to log out and back in again."
msgstr "A forbidden error was returned. You may need to log out and back in again."

msgid "A login email is on the way"
msgstr "A login email is on the way"

msgid "About Brave Ads"
msgstr "About Brave Ads"

msgid "Account"
msgstr "Account"

msgid "Account Balance"
msgstr "Account Balance"

msgid "Account Balance will be applied to this campaign"
msgstr "Account Balance will be applied to this campaign"

msgid "Account Settings"
msgstr "Account Settings"

msgid "Activate"
msgstr "Activate"

msgid "Ad"
msgstr "Ad"

msgid "Ad body is required"
msgstr "Ad body is required"

msgid "Ad body must be less than 60 characters"
msgstr "Ad body must be less than 60 characters"

msgid "Ad format"
msgstr "Ad format"

msgid "Ad Format"
msgstr "Ad Format"

msgid "Ad Name is required"
msgstr "Ad Name is required"

msgid "Ad Set"
msgstr "Ad Set"

msgid "Ad set name"
msgstr "Ad set name"

msgid "Ad Sets"
msgstr "Ad Sets"

msgid "Ad sets must have at least one ad"
msgstr "Ad sets must have at least one ad"

msgid "Ad title is required"
msgstr "Ad title is required"

msgid "Ad title must be less than 30 characters"
msgstr "Ad title must be less than 30 characters"

msgid "Ad type is required"
msgstr "Ad type is required"

msgid "Ad type must be notification"
msgstr "Ad type must be notification"

msgid "Add an existing ad"
msgstr "Add an existing ad"

msgid "Add Conversion tracking"
msgstr "Add Conversion tracking"

msgid "Additional Details"
msgstr "Additional Details"

msgid "Ads"
msgstr "Ads"

msgid "Ads are modular building blocks that can be paired with ad sets to build unique combinations. Your previously created ads will show here. Select by using the box next to the name. Use the \"Complete selection\" button to finish."
msgstr "Ads are modular building blocks that can be paired with ad sets to build unique combinations. Your previously created ads will show here. Select by using the box next to the name. Use the \"Complete selection\" button to finish."

msgid "Advertiser profile"
msgstr "Advertiser profile"

msgid "All OS"
msgstr "All OS"

msgid "All time"
msgstr "All time"

msgid "An ad from my Brave browser"
msgstr "An ad from my Brave browser"

msgid "An error has occurred while processing your request."
msgstr "An error has occurred while processing your request."

msgid "and no additional charges will be incurred."
msgstr "and no additional charges will be incurred."

msgid "and you will be charged {amountToCharge} USD."
msgstr "and you will be charged {amountToCharge} USD."

msgid "Android"
msgstr "Android"

msgid "API keys are used to get data from the reporting endpoints. They are unique to you."
msgstr "API keys are used to get data from the reporting endpoints. They are unique to you."

msgid "Are you sure you want to activate"
msgstr "Are you sure you want to activate"

msgid "Are you sure you want to modify \"{creativeName}\"?"
msgstr "Are you sure you want to modify \"{creativeName}\"?"

msgid "Are you sure you want to pause"
msgstr "Are you sure you want to pause"

msgid "At a marketing/media conference"
msgstr "At a marketing/media conference"

msgid "At least one country must be targeted"
msgstr "At least one country must be targeted"

msgid "At least one platform must be targeted"
msgstr "At least one platform must be targeted"

msgid "Audiences"
msgstr "Audiences"

msgid "Augment your marketing strategy"
msgstr "Augment your marketing strategy"

msgid "Automatic interest targeting"
msgstr "Automatic interest targeting"

msgid "Automotive"
msgstr "Automotive"

msgid "Back"
msgstr "Back"

msgid "Basic Attention Token"
msgstr "Basic Attention Token"

msgid "BAT holders can now also cash in their tokens to advertise their companies or products on the Brave Ads network."
msgstr "BAT holders can now also cash in their tokens to advertise their companies or products on the Brave Ads network."

msgid "Beauty & Personal Care"
msgstr "Beauty & Personal Care"

msgid "Billing Type"
msgstr "Billing Type"

msgid "Body"
msgstr "Body"

msgid "Body Preview"
msgstr "Body Preview"

msgid "Brave Ads deliver at the browser or search level, in dedicated placements that give your brand more spotlight and better engagement."
msgstr "Brave Ads deliver at the browser or search level, in dedicated placements that give your brand more spotlight and better engagement."

msgid "Brave cannot recover this key, which has been generated in your browser. You will need to confirm this private key on the next step before changes are saved."
msgstr "Brave cannot recover this key, which has been generated in your browser. You will need to confirm this private key on the next step before changes are saved."

msgid "Brave is an independent company dedicated to building a user-first Web. Our private, feature-rich browser and search engine are used by 70+ million people worldwide, with hundreds of thousands more downloading every day."
msgstr "Brave is an independent company dedicated to building a user-first Web. Our private, feature-rich browser and search engine are used by 70+ million people worldwide, with hundreds of thousands more downloading every day."

msgid "Brave is where early adopters thrive. We’re celebrating our crypto roots by offering new and returning Brave Ads customers half off their first self-managed campaign if they buy with BAT<0>*</0>"
msgstr "Brave is where early adopters thrive. We’re celebrating our crypto roots by offering new and returning Brave Ads customers half off their first self-managed campaign if they buy with BAT<0>*</0>"

msgid "Brave Search Ads"
msgstr "Brave Search Ads"

msgid "Brave Search Ads are built to be easy to manage. Once enabled, brands will benefit from a passive increase in traffic without the need to constantly monitor and tweak campaigns."
msgstr "Brave Search Ads are built to be easy to manage. Once enabled, brands will benefit from a passive increase in traffic without the need to constantly monitor and tweak campaigns."

msgid "Brave Search Ads are built to perform and convert as well as - or better than - Google Search Ad clicks."
msgstr "Brave Search Ads are built to perform and convert as well as - or better than - Google Search Ad clicks."

msgid "Brave’s 70+ million cord cutters, and tech savvy early adopters want privacy and performance over tracking and lag. Hundreds of thousands more make the switch every day. Want them to see your brand? Start your first campaign in minutes, and with as little as $500."
msgstr "Brave’s 70+ million cord cutters, and tech savvy early adopters want privacy and performance over tracking and lag. Hundreds of thousands more make the switch every day. Want them to see your brand? Start your first campaign in minutes, and with as little as $500."

msgid "Budget"
msgstr "Budget"

msgid "Business name"
msgstr "Business name"

msgid "Business name is required"
msgstr "Business name is required"

msgid "Business website"
msgstr "Business website"

msgid "Business Website is required"
msgstr "Business Website is required"

msgid "Campaign"
msgstr "Campaign"

msgid "Campaign creation is currently unavailable"
msgstr "Campaign creation is currently unavailable"

msgid "Campaign does not exist, or cannot be edited. Please try again later."
msgstr "Campaign does not exist, or cannot be edited. Please try again later."

msgid "Campaign Drafts"
msgstr "Campaign Drafts"

msgid "Campaign Format is required"
msgstr "Campaign Format is required"

msgid "Campaign has not started yet"
msgstr "Campaign has not started yet"

msgid "Campaign Name"
msgstr "Campaign Name"

msgid "Campaign Name is required"
msgstr "Campaign Name is required"

msgid "Campaign Settings"
msgstr "Campaign Settings"

msgid "Campaign Summary"
msgstr "Campaign Summary"

msgid "Campaigns"
msgstr "Campaigns"

msgid "Cancel"
msgstr "Cancel"

msgid "cannot create api key"
msgstr "cannot create api key"

msgid "cannot create session"
msgstr "cannot create session"

msgid "Check eligibility"
msgstr "Check eligibility"

msgid "Check if your brand is eligible for a <0>free trial</0> of Brave Search Ads. <1>Try Brave Search</1> to see why our users choose us over Google and Bing."
msgstr "Check if your brand is eligible for a <0>free trial</0> of Brave Search Ads. <1>Try Brave Search</1> to see why our users choose us over Google and Bing."

msgid "Check your brand's eligibility"
msgstr "Check your brand's eligibility"

msgid "Check your spam folder or <0>return to the login page</0> to try again."
msgstr "Check your spam folder or <0>return to the login page</0> to try again."

msgid "Choose a format for the campaign you would like to run."
msgstr "Choose a format for the campaign you would like to run."

msgid "City"
msgstr "City"

msgid "City is required"
msgstr "City is required"

msgid "Click on the secure login link in the email to access your Brave Ads account."
msgstr "Click on the secure login link in the email to access your Brave Ads account."

msgid "Click the continue button below to complete the login process."
msgstr "Click the continue button below to complete the login process."

msgid "Click Through Rate"
msgstr "Click Through Rate"

msgid "Click-through Conversions"
msgstr "Click-through Conversions"

msgid "Clicks"
msgstr "Clicks"

msgid "Clone"
msgstr "Clone"

msgid "Clone {campaignName}"
msgstr "Clone {campaignName}"

msgid "Clone campaign: \"{campaignName}\"?"
msgstr "Clone campaign: \"{campaignName}\"?"

msgid "Cloning a campaign will create a new draft campaign that inherits all properties of the original campaign, including ad sets. The new campaign will reuse any existing ads from the original campaign."
msgstr "Cloning a campaign will create a new draft campaign that inherits all properties of the original campaign, including ad sets. The new campaign will reuse any existing ads from the original campaign."

msgid "Close"
msgstr "Close"

msgid "Close Campaign"
msgstr "Close Campaign"

msgid "Closing a campaign will immediately stop it from running. Once it has stopped running, any remaining funds will be transferred back to your account in 24-48 hours."
msgstr "Closing a campaign will immediately stop it from running. Once it has stopped running, any remaining funds will be transferred back to your account in 24-48 hours."

msgid "Complete selection"
msgstr "Complete selection"

msgid "Complete your business profile to continue"
msgstr "Complete your business profile to continue"

msgid "Congratulations! 🎉"
msgstr "Congratulations! 🎉"

msgid "Consumer Goods (CPG)"
msgstr "Consumer Goods (CPG)"

msgid "Contact"
msgstr "Contact"

msgid "Contact sales"
msgstr "Contact sales"

msgid "Contact Sales"
msgstr "Contact Sales"

msgid "Content"
msgstr "Content"

msgid "Continue"
msgstr "Continue"

msgid "Conversion"
msgstr "Conversion"

msgid "Conversion Observation Window"
msgstr "Conversion Observation Window"

msgid "Conversion Rate"
msgstr "Conversion Rate"

msgid "Conversion URL must end in trailing asterisk (*)"
msgstr "Conversion URL must end in trailing asterisk (*)"

msgid "Conversion URL must not contain any whitespace"
msgstr "Conversion URL must not contain any whitespace"

msgid "Conversion URL must start with https://"
msgstr "Conversion URL must start with https://"

msgid "Conversion URL Pattern"
msgstr "Conversion URL Pattern"

msgid "Conversion URL required."
msgstr "Conversion URL required."

msgid "Conversions"
msgstr "Conversions"

msgid "Convert customers with AI-powered search ads"
msgstr "Convert customers with AI-powered search ads"

msgid "Copy this and keep this safe!"
msgstr "Copy this and keep this safe!"

msgid "Cost per Acquisition"
msgstr "Cost per Acquisition"

msgid "Cost per click"
msgstr "Cost per click"

msgid "Could not logout at this time. Please try again later."
msgstr "Could not logout at this time. Please try again later."

msgid "Country"
msgstr "Country"

msgid "Country is required"
msgstr "Country is required"

msgid "Country Targeting"
msgstr "Country Targeting"

msgid "CPA"
msgstr "CPA"

msgid "CPC (Clicks)"
msgstr "CPC (Clicks)"

msgid "CPM (Impressions)"
msgstr "CPM (Impressions)"

msgid "CPSV (Site Visits)"
msgstr "CPSV (Site Visits)"

msgid "Create & Submit For Approval"
msgstr "Create & Submit For Approval"

msgid "Create ad"
msgstr "Create ad"

msgid "Create new ad"
msgstr "Create new ad"

msgid "Create new keypair?"
msgstr "Create new keypair?"

msgid "create now"
msgstr "create now"

msgid "created"
msgstr "created"

msgid "Cryptocurrency/NFT"
msgstr "Cryptocurrency/NFT"

msgid "CTR"
msgstr "CTR"

msgid "Custom"
msgstr "Custom"

msgid "Daily"
msgstr "Daily"

msgid "Dashboard"
msgstr "Dashboard"

msgid "Data not valid for this private key"
msgstr "Data not valid for this private key"

msgid "Decrypt Conversion Data?"
msgstr "Decrypt Conversion Data?"

msgid "Define how you want your campaign to run."
msgstr "Define how you want your campaign to run."

msgid "Define the number of days Brave will observe conversions and attribute them to the campaign."
msgstr "Define the number of days Brave will observe conversions and attribute them to the campaign."

msgid "Disabled because you haven’t made any changes"
msgstr "Disabled because you haven’t made any changes"

msgid "Disabled due to validation errors"
msgstr "Disabled due to validation errors"

msgid "Discard ad"
msgstr "Discard ad"

msgid "Discard campaign"
msgstr "Discard campaign"

msgid "Dismissal Rate"
msgstr "Dismissal Rate"

msgid "Dismissals"
msgstr "Dismissals"

msgid "Documentation can be found <0>here</0> on how to use the API."
msgstr "Documentation can be found <0>here</0> on how to use the API."

msgid "Domain"
msgstr "Domain"

msgid "Domain is required"
msgstr "Domain is required"

msgid "Domain must not contain any whitespace"
msgstr "Domain must not contain any whitespace"

msgid "Domain to advertise"
msgstr "Domain to advertise"

msgid "Don’t see the email?"
msgstr "Don’t see the email?"

msgid "Download Report"
msgstr "Download Report"

msgid "Downvotes"
msgstr "Downvotes"

msgid "Draft"
msgstr "Draft"

msgid "Drafts"
msgstr "Drafts"

msgid "Edit"
msgstr "Edit"

msgid "Edit {campaignName}"
msgstr "Edit {campaignName}"

msgid "Edit ad"
msgstr "Edit ad"

msgid "Education"
msgstr "Education"

msgid "Email"
msgstr "Email"

msgid "Email address is required"
msgstr "Email address is required"

msgid "End"
msgstr "End"

msgid "End Date"
msgstr "End Date"

msgid "End date is required"
msgstr "End date is required"

msgid "End date must be after start date"
msgstr "End date must be after start date"

#~ msgid "End date must be before 1 July 2025"
#~ msgstr "End date must be before 1 July 2025"

msgid "End Time"
msgstr "End Time"

msgid "Energy and Utilities"
msgstr "Energy and Utilities"

msgid "Enter a URL that indicates a desired action you want to measure, like a subscription or purchase confirmation page. Brave will count unique visits to that page as conversions if a user has seen or clicked your ad."
msgstr "Enter a URL that indicates a desired action you want to measure, like a subscription or purchase confirmation page. Brave will count unique visits to that page as conversions if a user has seen or clicked your ad."

msgid "Enter Ads Manager"
msgstr "Enter Ads Manager"

msgid "Enter your email address to get a secure login link. Use this link to access your Brave Ads account."
msgstr "Enter your email address to get a secure login link. Use this link to access your Brave Ads account."

msgid "Entertainment"
msgstr "Entertainment"

msgid "Escape the low CTR of display banners"
msgstr "Escape the low CTR of display banners"

msgid "Example - https://brave.com/brave-rewards/"
msgstr "Example - https://brave.com/brave-rewards/"

msgid "Export"
msgstr "Export"

msgid "Failed to update profile: {errorMessage}"
msgstr "Failed to update profile: {errorMessage}"

msgid "Fashion"
msgstr "Fashion"

msgid "Feedback"
msgstr "Feedback"

msgid "Filter ads by name..."
msgstr "Filter ads by name..."

msgid "Finalize & submit"
msgstr "Finalize & submit"

msgid "Finance"
msgstr "Finance"

msgid "First party tracking acknowledgement is required"
msgstr "First party tracking acknowledgement is required"

msgid "Food & Beverage"
msgstr "Food & Beverage"

msgid "For businesses of all sizes. Create your campaign in minutes, starting with as little as $500 per month."
msgstr "For businesses of all sizes. Create your campaign in minutes, starting with as little as $500 per month."

msgid "Format"
msgstr "Format"

msgid "From"
msgstr "From"

msgid "From a Brave sales representative"
msgstr "From a Brave sales representative"

msgid "From a friend/colleague"
msgstr "From a friend/colleague"

msgid "From an influential person I follow online"
msgstr "From an influential person I follow online"

msgid "Full Landing Page URL"
msgstr "Full Landing Page URL"

msgid "Full name"
msgstr "Full name"

msgid "Full Name"
msgstr "Full Name"

msgid "Full name is required"
msgstr "Full name is required"

msgid "Gaming"
msgstr "Gaming"

msgid "General Ad Inquiries"
msgstr "General Ad Inquiries"

msgid "Generate"
msgstr "Generate"

msgid "Generate a keypair for your account. Brave Ads will use your account’s public key to sign and encrypt conversion data. Only your organization will have access to the private key, which can be used to decrypt and view conversion data."
msgstr "Generate a keypair for your account. Brave Ads will use your account’s public key to sign and encrypt conversion data. Only your organization will have access to the private key, which can be used to decrypt and view conversion data."

msgid "Generate a new API key?"
msgstr "Generate a new API key?"

msgid "Generate API Key"
msgstr "Generate API Key"

msgid "Generating a new API key will result in the deactivation of your previous key, rendering it unusable for future requests. Make sure to update your code with the new key to avoid disruptions in your application’s functionality."
msgstr "Generating a new API key will result in the deactivation of your previous key, rendering it unusable for future requests. Make sure to update your code with the new key to avoid disruptions in your application’s functionality."

msgid "Get a free testing period"
msgstr "Get a free testing period"

msgid "Get in touch with our team"
msgstr "Get in touch with our team"

msgid "Get in touch."
msgstr "Get in touch."

msgid "Get incremental traffic with paid ads on the world's fastest growing search engine."
msgstr "Get incremental traffic with paid ads on the world's fastest growing search engine."

msgid "Get login link"
msgstr "Get login link"

msgid "Get started"
msgstr "Get started"

msgid "Get to your first million users with powerful ad placements on the world’s fastest-growing alternative browser & search engine."
msgstr "Get to your first million users with powerful ad placements on the world’s fastest-growing alternative browser & search engine."

msgid "Have specific questions?"
msgstr "Have specific questions?"

msgid "Healthcare"
msgstr "Healthcare"

msgid "Help Center"
msgstr "Help Center"

msgid "Hi"
msgstr "Hi"

msgid "Home & Garden"
msgstr "Home & Garden"

msgid "Hourly"
msgstr "Hourly"

msgid "I have reviewed and agree to the <0>Advertiser Privacy Policy</0> and platform <1>Terms of Service</1> applicable to Brave Ads."
msgstr "I have reviewed and agree to the <0>Advertiser Privacy Policy</0> and platform <1>Terms of Service</1> applicable to Brave Ads."

msgid "I understand that first-party analytics are necessary for independent reporting."
msgstr "I understand that first-party analytics are necessary for independent reporting."

msgid "I understand that I can only run ad campaigns in English, Spanish, and Portuguese."
msgstr "I understand that I can only run ad campaigns in English, Spanish, and Portuguese."

msgid "I understand that payment is required before ad campaigns can be launched."
msgstr "I understand that payment is required before ad campaigns can be launched."

msgid "I would like to receive marketing emails about new features and promotions from Brave Ads"
msgstr "I would like to receive marketing emails about new features and promotions from Brave Ads"

msgid "Id"
msgstr "Id"

msgid "Impressions"
msgstr "Impressions"

msgid "In a blog post/news article"
msgstr "In a blog post/news article"

msgid "In a newsletter I subscribe to"
msgstr "In a newsletter I subscribe to"

msgid "In a post by Brave on LinkedIn"
msgstr "In a post by Brave on LinkedIn"

msgid "In a video on YouTube"
msgstr "In a video on YouTube"

msgid "In your local time this is"
msgstr "In your local time this is"

msgid "Include campaigns that ended over 6 months ago"
msgstr "Include campaigns that ended over 6 months ago"

msgid "Increase Budget"
msgstr "Increase Budget"

msgid "Increase budget for campaign: <0>{campaignName}</0>?"
msgstr "Increase budget for campaign: <0>{campaignName}</0>?"

msgid "invalid session"
msgstr "invalid session"

msgid "Invalid Session"
msgstr "Invalid Session"

msgid "Invalid Token"
msgstr "Invalid Token"

msgid "iOS"
msgstr "iOS"

msgid "is not"
msgstr "is not"

msgid "It is a modern <0>advertiser-first</0> ad platform made to help brands reach new users. Brave Ads are discrete, unobtrusive first-party ads built directly into the browser and search engine. Brave’s innovative on-device targeting respects a user’s desire for privacy while still delivering personalized ads based on their interests, which drives high ROI for advertisers."
msgstr "It is a modern <0>advertiser-first</0> ad platform made to help brands reach new users. Brave Ads are discrete, unobtrusive first-party ads built directly into the browser and search engine. Brave’s innovative on-device targeting respects a user’s desire for privacy while still delivering personalized ads based on their interests, which drives high ROI for advertisers."

msgid "It is scheduled to start {campaignStartFromNow}."
msgstr "It is scheduled to start {campaignStartFromNow}."

msgid "Key copied"
msgstr "Key copied"

msgid "Keypairs"
msgstr "Keypairs"

msgid "Language acknowledgement is required"
msgstr "Language acknowledgement is required"

msgid "Last 30 days"
msgstr "Last 30 days"

msgid "Last 7 days"
msgstr "Last 7 days"

msgid "Last month"
msgstr "Last month"

msgid "Learn More"
msgstr "Learn More"

msgid "Legal and Professional Services"
msgstr "Legal and Professional Services"

msgid "Let Brave pick categories for me."
msgstr "Let Brave pick categories for me."

msgid "Lifetime Budget"
msgstr "Lifetime Budget"

msgid "Lifetime budget is required"
msgstr "Lifetime budget is required"

msgid "Lifetime budget must be ${MIN_PER_CAMPAIGN} or more"
msgstr "Lifetime budget must be ${MIN_PER_CAMPAIGN} or more"

msgid "Lifetime budget must be higher for date range provided. Minimum ${min}."
msgstr "Lifetime budget must be higher for date range provided. Minimum ${min}."

msgid "Like your campaign's performance? Increase the budget to expand its reach and connect with more potential customers. Specify below how much you would like to add to your current budget of <0>{previousBudget}</0>"
msgstr "Like your campaign's performance? Increase the budget to expand its reach and connect with more potential customers. Specify below how much you would like to add to your current budget of <0>{previousBudget}</0>"

msgid "Linux"
msgstr "Linux"

msgid "Locations"
msgstr "Locations"

msgid "Log in"
msgstr "Log in"

msgid "Log into your Brave Ads account"
msgstr "Log into your Brave Ads account"

msgid "Logout"
msgstr "Logout"

msgid "macOS"
msgstr "macOS"

msgid "Make payment & submit for approval"
msgstr "Make payment & submit for approval"

msgid "Make sure to include your brand name in the title OR body of the ad. Otherwise, it will be rejected."
msgstr "Make sure to include your brand name in the title OR body of the ad. Otherwise, it will be rejected."

msgid "Manufacturing and Industrial"
msgstr "Manufacturing and Industrial"

msgid "Max 30 Characters"
msgstr "Max 30 Characters"

msgid "Max 60 Characters"
msgstr "Max 60 Characters"

msgid "Modifying an ad will immediately put it into review. This means it will no longer be shown to users until it is approved."
msgstr "Modifying an ad will immediately put it into review. This means it will no longer be shown to users until it is approved."

msgid "Modifying an ad will immediately put it into review. This means it will no longer be shown to users until it is approved. This ad is also shared across {campaignLength} campaigns. Any modifications made will be effective for all campaigns using this creative."
msgstr "Modifying an ad will immediately put it into review. This means it will no longer be shown to users until it is approved. This ad is also shared across {campaignLength} campaigns. Any modifications made will be effective for all campaigns using this creative."

msgid "Modifying the state of this ad will effect more than one campaign:"
msgstr "Modifying the state of this ad will effect more than one campaign:"

msgid "Name"
msgstr "Name"

msgid "Name your ad set to distinguish it from others."
msgstr "Name your ad set to distinguish it from others."

msgid "New"
msgstr "New"

msgid "New ad"
msgstr "New ad"

msgid "New API Key"
msgstr "New API Key"

msgid "New Campaign"
msgstr "New Campaign"

msgid "New campaigns typically take up to 48 hours to review during a regular U.S. business week."
msgstr "New campaigns typically take up to 48 hours to review during a regular U.S. business week."

msgid "New Keypair"
msgstr "New Keypair"

msgid "New tab takeover"
msgstr "New tab takeover"

msgid "New tab takeovers"
msgstr "New tab takeovers"

msgid "New users are switching to Brave Search every single day. Don't miss out on meeting their intent to shop your product or services."
msgstr "New users are switching to Brave Search every single day. Don't miss out on meeting their intent to shop your product or services."

msgid "Newsfeed"
msgstr "Newsfeed"

msgid "Next"
msgstr "Next"

msgid "No"
msgstr "No"

msgid "No {billingType} pricing available for {label}, contact selfserve@brave.com for help"
msgstr "No {billingType} pricing available for {label}, contact selfserve@brave.com for help"

msgid "No conversion URL setup"
msgstr "No conversion URL setup"

msgid "No file result"
msgstr "No file result"

msgid "No previous ads available"
msgstr "No previous ads available"

msgid "no session created"
msgstr "no session created"

msgid "Non-Profit and NGOs"
msgstr "Non-Profit and NGOs"

msgid "Notes"
msgstr "Notes"

msgid "Notification"
msgstr "Notification"

msgid "Notification ad"
msgstr "Notification ad"

msgid "Notification ads"
msgstr "Notification ads"

msgid "Observation Window"
msgstr "Observation Window"

msgid "Observation window must be 1, 7, or 30 days."
msgstr "Observation window must be 1, 7, or 30 days."

msgid "Observation window required."
msgstr "Observation window required."

msgid "On / Off"
msgstr "On / Off"

msgid "On a podcast I listen to"
msgstr "On a podcast I listen to"

msgid "On/Off"
msgstr "On/Off"

msgid "Once confirmed, your account’s keypair will be replaced with the new keypair."
msgstr "Once confirmed, your account’s keypair will be replaced with the new keypair."

msgid "or sign in using a password"
msgstr "or sign in using a password"

msgid "or sign in using a secure link"
msgstr "or sign in using a secure link"

msgid "OS"
msgstr "OS"

msgid "Other"
msgstr "Other"

msgid "Other (please specify)"
msgstr "Other (please specify)"

msgid "Other accounts"
msgstr "Other accounts"

msgid "Other source"
msgstr "Other source"

msgid "Password"
msgstr "Password"

msgid "Pause"
msgstr "Pause"

msgid "Pay with BAT to get <0>50% off</0> your first self-managed campaign."
msgstr "Pay with BAT to get <0>50% off</0> your first self-managed campaign."

msgid "Payment"
msgstr "Payment"

msgid "Payment acknowledgement is required"
msgstr "Payment acknowledgement is required"

msgid "Payment is required before launching your campaign."
msgstr "Payment is required before launching your campaign."

msgid "Performance Report"
msgstr "Performance Report"

msgid "Platforms"
msgstr "Platforms"

msgid "Please ask your Account Manager for reports on campaigns of this format."
msgstr "Please ask your Account Manager for reports on campaigns of this format."

msgid "Please confirm your account’s new private key:"
msgstr "Please confirm your account’s new private key:"

msgid "Please enter a username and password"
msgstr "Please enter a username and password"

msgid "Please enter a valid amount"
msgstr "Please enter a valid amount"

msgid "Please enter a valid domain, for example: brave.com"
msgstr "Please enter a valid domain, for example: brave.com"

msgid "Please enter a valid email address"
msgstr "Please enter a valid email address"

msgid "Please enter a valid URL, for example https://brave.com"
msgstr "Please enter a valid URL, for example https://brave.com"

msgid "Please enter a valid URL, for example https://brave.com/product/*"
msgstr "Please enter a valid URL, for example https://brave.com/product/*"

msgid "Please enter an email."
msgstr "Please enter an email."

msgid "Please let us know how you heard about Brave Ads"
msgstr "Please let us know how you heard about Brave Ads"

msgid "Please let us know why you're interested in Brave Ads"
msgstr "Please let us know why you're interested in Brave Ads"

msgid "Please refresh the page to try again, or email <0/> for assistance."
msgstr "Please refresh the page to try again, or email <0/> for assistance."

msgid "Please see our <0>Advertiser Privacy Policy</0> and <1>Terms of Service</1> applicable to Brave Ads."
msgstr "Please see our <0>Advertiser Privacy Policy</0> and <1>Terms of Service</1> applicable to Brave Ads."

msgid "Please select a vertical"
msgstr "Please select a vertical"

msgid "Please specify how you heard about Brave Ads"
msgstr "Please specify how you heard about Brave Ads"

msgid "Price"
msgstr "Price"

msgid "Price is a required field"
msgstr "Price is a required field"

msgid "Pricing"
msgstr "Pricing"

msgid "Pricing Type"
msgstr "Pricing Type"

msgid "Pricing type is a required field"
msgstr "Pricing type is a required field"

msgid "Pricing type must be CPM, CPC, or CPSV"
msgstr "Pricing type must be CPM, CPC, or CPSV"

msgid "Primary region of business"
msgstr "Primary region of business"

msgid "Primary region of business is required"
msgstr "Primary region of business is required"

msgid "Private Key"
msgstr "Private Key"

msgid "Proceed"
msgstr "Proceed"

msgid "Profile"
msgstr "Profile"

msgid "Profile API Key"
msgstr "Profile API Key"

msgid "Profile Details"
msgstr "Profile Details"

msgid "Query parameter"
msgstr "Query parameter"

msgid "Query string parameters"
msgstr "Query string parameters"

msgid "Reach 70+ million highly engaged, otherwise unreachable users."
msgstr "Reach 70+ million highly engaged, otherwise unreachable users."

msgid "Reach new audiences you're missing"
msgstr "Reach new audiences you're missing"

msgid "Read more at"
msgstr "Read more at"

msgid "Ready to reach your first million users? Start your first campaign today."
msgstr "Ready to reach your first million users? Start your first campaign today."

msgid "Real Estate"
msgstr "Real Estate"

msgid "Remove"
msgstr "Remove"

msgid "Remove Conversion tracking"
msgstr "Remove Conversion tracking"

msgid "Retail"
msgstr "Retail"

msgid "Return"
msgstr "Return"

msgid "Return to dashboard"
msgstr "Return to dashboard"

msgid "Review"
msgstr "Review"

msgid "Review ads"
msgstr "Review ads"

msgid "Sample Queries"
msgstr "Sample Queries"

msgid "Save"
msgstr "Save"

msgid "Save ad"
msgstr "Save ad"

msgid "Saving..."
msgstr "Saving..."

msgid "Search homepage"
msgstr "Search homepage"

msgid "Search keyword"
msgstr "Search keyword"

msgid "Search keyword ads"
msgstr "Search keyword ads"

msgid "searchads@brave.com"
msgstr "searchads@brave.com"

msgid "Select Account"
msgstr "Select Account"

msgid "Select one campaign to clone"
msgstr "Select one campaign to clone"

msgid "Select one campaign to edit"
msgstr "Select one campaign to edit"

msgid "Select the ads you would like to include in this ad set. Only checked ads are included."
msgstr "Select the ads you would like to include in this ad set. Only checked ads are included."

msgid "Select the audience segments to target"
msgstr "Select the audience segments to target"

msgid "Select the geographic regions where your ads will be shown."
msgstr "Select the geographic regions where your ads will be shown."

msgid "Select the interest segments and platforms you would like to target."
msgstr "Select the interest segments and platforms you would like to target."

msgid "Select the platforms to target"
msgstr "Select the platforms to target"

msgid "Selected ads"
msgstr "Selected ads"

msgid "Set up a trial campaign in minutes."
msgstr "Set up a trial campaign in minutes."

msgid "Setup Progress"
msgstr "Setup Progress"

msgid "Simple ads to reach digital trend-setters around the world"
msgstr "Simple ads to reach digital trend-setters around the world"

msgid "Site Visit Rate"
msgstr "Site Visit Rate"

msgid "Site visits"
msgstr "Site visits"

msgid "Site Visits"
msgstr "Site Visits"

msgid "Skip survey and continue"
msgstr "Skip survey and continue"

msgid "Something went wrong."
msgstr "Something went wrong."

msgid "Spend"
msgstr "Spend"

msgid "Sponsored"
msgstr "Sponsored"

msgid "Sports"
msgstr "Sports"

msgid "Start"
msgstr "Start"

msgid "Start a campaign with BAT"
msgstr "Start a campaign with BAT"

msgid "Start Date"
msgstr "Start Date"

msgid "Start Date is required"
msgstr "Start Date is required"

msgid "Start Date must be minimum of 2 days from today"
msgstr "Start Date must be minimum of 2 days from today"

msgid "Start fast and experiment"
msgstr "Start fast and experiment"

msgid "Start Time"
msgstr "Start Time"

msgid "Start your company profile"
msgstr "Start your company profile"

msgid "State"
msgstr "State"

msgid "Status"
msgstr "Status"

msgid "Street address"
msgstr "Street address"

msgid "Street address is required"
msgstr "Street address is required"

msgid "Submit"
msgstr "Submit"

msgid "Success! Check your email."
msgstr "Success! Check your email."

msgid "Support"
msgstr "Support"

msgid "Take our survey!"
msgstr "Take our survey!"

msgid "Target URL"
msgstr "Target URL"

msgid "Target URL is a required field"
msgstr "Target URL is a required field"

msgid "Target URL is not valid"
msgstr "Target URL is not valid"

msgid "Target URL not validated"
msgstr "Target URL not validated"

msgid "Targeting"
msgstr "Targeting"

msgid "Technology/Software"
msgstr "Technology/Software"

msgid "Telecommunications"
msgstr "Telecommunications"

msgid "Tell us why you're interested in Brave Ads"
msgstr "Tell us why you're interested in Brave Ads"

msgid "Terms & Conditions acknowledgement is required"
msgstr "Terms & Conditions acknowledgement is required"

msgid "The <0>Basic Attention Token (BAT)</0> is Brave’s native crypto token. Brave Browser users who opt into <1>Brave Rewards</1> can earn BAT just for opting into viewing ads from the Brave Ads network. Earners can hold BAT like any other crypto asset, trade it, cash it in, or even donate it to their favorite creators."
msgstr "The <0>Basic Attention Token (BAT)</0> is Brave’s native crypto token. Brave Browser users who opt into <1>Brave Rewards</1> can earn BAT just for opting into viewing ads from the Brave Ads network. Earners can hold BAT like any other crypto asset, trade it, cash it in, or even donate it to their favorite creators."

msgid "The campaign will likely stop running before the end date provided due to budget constraints."
msgstr "The campaign will likely stop running before the end date provided due to budget constraints."

msgid "The current value for this metric may be an underestimate."
msgstr "The current value for this metric may be an underestimate."

msgid "The following query string parameters will be added to your landing page URLs. This will allow you to track the performance of your ads."
msgstr "The following query string parameters will be added to your landing page URLs. This will allow you to track the performance of your ads."

msgid "The magic link you have requested has either expired or has already been used. Please return to the login page and try again."
msgstr "The magic link you have requested has either expired or has already been used. Please return to the login page and try again."

msgid "The username or password did not match our records."
msgstr "The username or password did not match our records."

msgid "This key is unique to you, make sure to safely store it and avoid sharing it with others to prevent unauthorized access."
msgstr "This key is unique to you, make sure to safely store it and avoid sharing it with others to prevent unauthorized access."

msgid "This month"
msgstr "This month"

msgid "Time Zone"
msgstr "Time Zone"

msgid "Title"
msgstr "Title"

msgid "Title Preview"
msgstr "Title Preview"

msgid "To"
msgstr "To"

msgid "To protect user’s privacy, verified ad conversion data is encrypted so that the identities of converted users remain anonymous to Brave. You can decrypt the conversion data in the CSV file by providing your private key here. If no key is provided, you will receive the encrypted conversion data. Your private key will never be sent to or stored on any Brave servers."
msgstr "To protect user’s privacy, verified ad conversion data is encrypted so that the identities of converted users remain anonymous to Brave. You can decrypt the conversion data in the CSV file by providing your private key here. If no key is provided, you will receive the encrypted conversion data. Your private key will never be sent to or stored on any Brave servers."

msgid "Today"
msgstr "Today"

msgid "Travel & Hospitality"
msgstr "Travel & Hospitality"

msgid "Try Brave Search Ads risk-free to see how the ads perform for your website."
msgstr "Try Brave Search Ads risk-free to see how the ads perform for your website."

msgid "Unable to clone campaign"
msgstr "Unable to clone campaign"

msgid "Unable to create a new campaign"
msgstr "Unable to create a new campaign"

msgid "Unable to Create Campaign."
msgstr "Unable to Create Campaign."

msgid "Unable to create payment session. Please try again."
msgstr "Unable to create payment session. Please try again."

msgid "Unable to decrypt conversion data"
msgstr "Unable to decrypt conversion data"

msgid "Unable to download CSV"
msgstr "Unable to download CSV"

msgid "Unable to get campaign information for ad"
msgstr "Unable to get campaign information for ad"

msgid "Unable to get profile information"
msgstr "Unable to get profile information"

msgid "Unable to load ad"
msgstr "Unable to load ad"

msgid "Unable to load reporting details for campaign: {campaignName}"
msgstr "Unable to load reporting details for campaign: {campaignName}"

msgid "Unable to login."
msgstr "Unable to login."

msgid "Unable to register your organization at this time. Please try again later."
msgstr "Unable to register your organization at this time. Please try again later."

msgid "Unable to retrieve Campaign data."
msgstr "Unable to retrieve Campaign data."

msgid "Unable to retrieve images"
msgstr "Unable to retrieve images"

msgid "Unable to save ad"
msgstr "Unable to save ad"

msgid "Unable to submit registration"
msgstr "Unable to submit registration"

msgid "Unable to update Advertiser."
msgstr "Unable to update Advertiser."

msgid "Unable to Update Campaign."
msgstr "Unable to Update Campaign."

msgid "Unexpected error validating your credentials. Please try again later."
msgstr "Unexpected error validating your credentials. Please try again later."

msgid "Unknown"
msgstr "Unknown"

msgid "Update & Submit For Approval"
msgstr "Update & Submit For Approval"

msgid "Upvotes"
msgstr "Upvotes"

msgid "URL is valid."
msgstr "URL is valid."

msgid "URL must not contain any whitespace"
msgstr "URL must not contain any whitespace"

msgid "URL must start with https://"
msgstr "URL must start with https://"

msgid "URL Pattern"
msgstr "URL Pattern"

msgid "URL should have a trailing asterisk - Example: https://brave.com/products/*"
msgstr "URL should have a trailing asterisk - Example: https://brave.com/products/*"

msgid "Use existing ads"
msgstr "Use existing ads"

msgid "Validating URL..."
msgstr "Validating URL..."

msgid "Value"
msgstr "Value"

msgid "Verified Conversions Report"
msgstr "Verified Conversions Report"

msgid "Verticals"
msgstr "Verticals"

msgid "View profile"
msgstr "View profile"

msgid "View-through Conversions"
msgstr "View-through Conversions"

msgid "Visit Help Center"
msgstr "Visit Help Center"

msgid "We value your feedback and would love to hear your thoughts on your recent experience. <0/>Your input will help us improve the Brave Ads platform to better meet your needs. <1/>It only takes a few minutes and your participation will be greatly appreciated! <2/>Thank you for using Brave Ads! <3/>"
msgstr "We value your feedback and would love to hear your thoughts on your recent experience. <0/>Your input will help us improve the Brave Ads platform to better meet your needs. <1/>It only takes a few minutes and your participation will be greatly appreciated! <2/>Thank you for using Brave Ads! <3/>"

msgid "Website must not contain any whitespace"
msgstr "Website must not contain any whitespace"

msgid "Website must start with https://"
msgstr "Website must start with https://"

msgid "What is Brave Ads?"
msgstr "What is Brave Ads?"

msgid "What’s BAT?"
msgstr "What’s BAT?"

msgid "What’s Brave?"
msgstr "What’s Brave?"

msgid "Where did you hear about Brave Ads"
msgstr "Where did you hear about Brave Ads"

msgid "While looking up alternatives to Google Ads"
msgstr "While looking up alternatives to Google Ads"

msgid "Why use Brave Ads?"
msgstr "Why use Brave Ads?"

msgid "Windows"
msgstr "Windows"

msgid "Work email"
msgstr "Work email"

msgid "Yes"
msgstr "Yes"

msgid "You are about to close this campaign."
msgstr "You are about to close this campaign."

msgid "You are attempting to create a new keypair, this will replace any of your account’s existing keypairs. Please note, previous keypairs cannot be retrieved or used once replaced."
msgstr "You are attempting to create a new keypair, this will replace any of your account’s existing keypairs. Please note, previous keypairs cannot be retrieved or used once replaced."

msgid "You are logging into the Brave Ads Manager Dashboard."
msgstr "You are logging into the Brave Ads Manager Dashboard."

msgid "You have {errorCount} errors that must be fixed before submitting."
msgstr "You have {errorCount} errors that must be fixed before submitting."

msgid "You have unsaved changes"
msgstr "You have unsaved changes"

msgid "You may have access to multiple accounts. Switch between them here."
msgstr "You may have access to multiple accounts. Switch between them here."

msgid "You will soon receive an email with the next steps of registration. While you wait, we recommend you check out our help center to get helpful information for getting started with Brave Ads."
msgstr "You will soon receive an email with the next steps of registration. While you wait, we recommend you check out our help center to get helpful information for getting started with Brave Ads."

msgid "Your account has a balance of {accountBalance} USD. This will be applied to your campaign"
msgstr "Your account has a balance of {accountBalance} USD. This will be applied to your campaign"

msgid "Your account’s new private key will be:"
msgstr "Your account’s new private key will be:"

msgid "Your account’s public key:"
msgstr "Your account’s public key:"

msgid "Your campaign has been created and is now being reviewed by our ads team. <0/>We’ll be in contact as soon as your campaign is approved and activated."
msgstr "Your campaign has been created and is now being reviewed by our ads team. <0/>We’ll be in contact as soon as your campaign is approved and activated."

msgid "Your campaign has been updated! <0/>If you added new ads, we’ll be in contact as soon as they are approved and activated. <1/>Thank you for using Brave Ads!"
msgstr "Your campaign has been updated! <0/>If you added new ads, we’ll be in contact as soon as they are approved and activated. <1/>Thank you for using Brave Ads!"

msgid "Your current account balance"
msgstr "Your current account balance"

msgid "Your trial campaign will be reviewed by an Account Manager. Add any notes or questions for them here."
msgstr "Your trial campaign will be reviewed by an Account Manager. Add any notes or questions for them here."

msgid "Zip / Postal Code"
msgstr "Zip / Postal Code"
